var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c(_vm.tournamentComponent,{tag:"component",attrs:{"id":_vm.id,"tournament-data":_vm.tournamentData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }